import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=52c1fac9&scoped=true&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&id=52c1fac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1fac9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c1fac9')) {
      api.createRecord('52c1fac9', component.options)
    } else {
      api.reload('52c1fac9', component.options)
    }
    module.hot.accept("./tag.vue?vue&type=template&id=52c1fac9&scoped=true&", function () {
      api.rerender('52c1fac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/tag/tag.vue"
export default component.exports